import { Text, HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../components/TableContent';

import { CancelButton } from './components/CancelButton';
import { StatusIcon } from './components/StatusIcon';
import { WithdrawalItemTypes } from './types';

export const WithdrawalItemMobile: React.FC<WithdrawalItemTypes.Props> = ({ item, onCancel }) => {
  // const handleDownloadReceipt = () => {
  //   onDownloadReceipt(item.transactionIdNormalized, item.accountId);
  // };

  const handleCancel = () => {
    onCancel(item.transactionIdNormalized, item.accountId);
  };

  return (
    <TableContent
      direction="column"
      space={Spacing['stack.xxxs']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}>
      <HStack
        alignItems="center"
        space={Spacing['stack.nano']}
        justifyContent="space-between"
        width="100%">
        <Text>Data de solicitação</Text>
        <Text>{item.transactionDateNormalized}</Text>
      </HStack>
      <HStack
        alignItems="center"
        space={Spacing['stack.nano']}
        justifyContent="space-between"
        width="100%">
        <Text>Data para saque</Text>
        <Text>{item.scheduledDateNormalized}</Text>
      </HStack>
      <HStack
        alignItems="center"
        space={Spacing['stack.nano']}
        justifyContent="space-between"
        width="100%">
        <Text>Valor (R$)</Text>
        <Text>{item.amountNormalized}</Text>
      </HStack>
      <HStack
        alignItems="center"
        space={Spacing['stack.nano']}
        justifyContent="space-between"
        width="100%">
        <Text>Status</Text>
        <StatusIcon item={item} />
      </HStack>
      <HStack
        alignItems="center"
        space={Spacing['stack.nano']}
        justifyContent="flex-end"
        width="100%">
        {/*<DownloadButton onPress={handleDownloadReceipt} isDisabled={!item.haveReceipt} />*/}
        <CancelButton onPress={handleCancel} isDisabled={!item.canCancel} />
      </HStack>
    </TableContent>
  );
};
